import React, { Component } from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components';
import { getSpecificIcon } from '../../helpers/producttypes.js';
import { DropdownOpenedIcon , DropdownClosedIcon} from '../../icons'
import styles from './defaultStyles';

class CategorySelector extends Component {
  handleChange = (category) => {
    const { onChange, selectedAttributes } = this.props;
    const isChecked = this.isItemChecked(selectedAttributes, category.name);
    let values = [...selectedAttributes];
    if (isChecked) {
      values.splice(values.indexOf(category.name), 1);
    } else {
      values.push(category.name);
    }
    onChange(values);
  };

  getIcon = (name) => {
    const { selectedItemColor, bodyTextColor, selectedAttributes } = this.props;
    const isChecked = this.isItemChecked(selectedAttributes, name);
    const color = isChecked ? selectedItemColor : bodyTextColor;
    return getSpecificIcon(name, color);
  }
  
  renderItems(props) {
    const { selectedItemColor, bodyTextColor, categories, selectedAttributes } = props;
    return categories.map((category, index) => (
            <ItemWrapperDivStyled key={index}>
               <ItemDivStyled onClick={this.handleChange.bind(null, category)}>
                <ItemIconWrapperDiv> {this.getIcon(category.name)} </ItemIconWrapperDiv><ItemName bodyTextColor={bodyTextColor} color={selectedItemColor} isChecked={this.isItemChecked(selectedAttributes, category.name)}>{category.name.toLowerCase()}</ItemName>
               </ItemDivStyled>
            </ItemWrapperDivStyled>
        ))
  }

  isItemChecked(selectedValues, categoryName) {
    return selectedValues && selectedValues.indexOf(categoryName) > -1;
  }

  headerIcon(isOpened, selectedItemColor) {
    return (
      <HeaderIconWrapperDivStyled>
        {isOpened && <DropdownOpenedIcon style={styles.dropDownIcon} />}
        {!isOpened && <DropdownClosedIcon style={styles.dropDownIcon} />}
      </HeaderIconWrapperDivStyled>
    )
  }

  render() {
    const { selectedItemColor, bodyTextColor, categories, selectedAttributes } = this.props;
    return (
       <CategoryWrapperDivStyled>
          <HeaderDivStyled bodyTextColor={bodyTextColor} onClick={this.props.onClick}>Category{this.headerIcon(this.props.isOpened, selectedItemColor)}</HeaderDivStyled>
          { this.props.isOpened && 
            <SlideDownDiv itemsLength={categories.length}>
              {this.renderItems({ categories, selectedAttributes, selectedItemColor, bodyTextColor })}
            </SlideDownDiv>
          }
       </CategoryWrapperDivStyled>
    ) 
  }
}

CategorySelector.propTypes = {
  onClick: PropTypes.func,
  isOpened: PropTypes.bool,
  selectedItemColor: PropTypes.string,
  bodyTextColor: PropTypes.string,
  categories: PropTypes.array,
  selectedAttributes: PropTypes.array,
  onChange: PropTypes.func,
}

export default CategorySelector;

const SlideDownDiv = styled.div `
    margin: 5px 0 0 0;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    height: ${props => { 
      if (props.itemsLength <= 6) {
        return '83px';
      } else if (props.itemsLength > 6 && props.itemsLength < 9) {
        return '157px';
      } else if (props.itemsLength > 8) {
        return '196px'
      }
    } }
`;

const CategoryWrapperDivStyled = styled.div `
  padding: 5px 0;
  width: 100%;
`;

const HeaderDivStyled = styled.div `
   text-align: center;
   cursor: pointer;
   font-weight: 400;
   font-size: 16px;
   display: flex;
   align-items: center;
   justify-content: space-between;
   color: ${props => props.bodyTextColor};
`;

const HeaderIconWrapperDivStyled = styled.div `
  padding-top: 3px;
`;

const ItemWrapperDivStyled = styled.div `
  padding: 0 0 10px;
  &:last-child {
    padding: 0;
  }
`;

const ItemIconWrapperDiv = styled.div `
  margin-right: 5px;
`;

const ItemName = styled.div `
  font-size: 16px;
  text-transform: capitalize;
  color: ${props => props.isChecked ? props.color : props.bodyTextColor };
`;

const ItemDivStyled = styled.div `
    display: flex;
    flex-direction: row;
    width: 102px;
    align-items: center;
    flex-wrap: nowrap;
    cursor: pointer;
`;




// WEBPACK FOOTER //
// ./src/components/CategorySelector/CategorySelector.jsx